import type { BusinessPolicySnapshot } from '../policy/business-policy.ts';
import type { AvailabilityProjection } from './availability-authority.ts';

export function composeBusinessPolicyWithAvailability(
  base: BusinessPolicySnapshot,
  projection: AvailabilityProjection,
): BusinessPolicySnapshot {
  const next = structuredClone(base);
  const nodes = { ...next.availability.nodes };

  for (const node of projection.nodes) {
    if (Object.prototype.hasOwnProperty.call(nodes, node.nodeId)) {
      nodes[node.nodeId] = node.status;
    }
  }

  return {
    ...next,
    availabilityRevision: projection.revision === 0
      ? next.availabilityRevision
      : `${next.availabilityRevision}::operational-${projection.revision}`,
    availability: {
      nodes,
      productRequirements: next.availability.productRequirements,
    },
  };
}
